import { createContext, useContext } from "react";

import PNIRootStore, { PNIRootStoreInstance } from "./PNIRootStore";
/**
 * Create a context we can use to
 * - Provide access to our stores from our root component
 * - Consume stores in our screens (or other components, though it's
 *   preferable to just connect screens)
 */
const PNIRootStoreContext = createContext(PNIRootStore);

/**
 * The provider our root component will use to expose the root store
 */
export const PNIRootStoreProvider = PNIRootStoreContext.Provider;

/**
 * A hook that screens can use to gain access to our stores, with
 * `const { someStore, someOtherStore } = useStores()`,
 * or less likely: `const PNIRootStore = useStores()`
 */
export const usePNIStores = (): PNIRootStoreInstance => useContext(PNIRootStoreContext);

export { default as PNIRootStore } from "./PNIRootStore";
